/** @jsx  jsx */
import { css } from '@emotion/core';
import { fontWeights } from '../../../styles/typography';

export const priceCss = css({
  fontWeight: fontWeights.medium,
});
